import firebase from 'firebase';
var firebaseConfig = {
  apiKey: "AIzaSyDiBRzjg-IgD8qL4Wf_hWqtpkMtjp0qR94",
  authDomain: "cv-builder-bf9f4.firebaseapp.com",
  databaseURL: "https://cv-builder-bf9f4.firebaseio.com",
  projectId: "cv-builder-bf9f4",
  storageBucket: "cv-builder-bf9f4.appspot.com",
  messagingSenderId: "756285273237",
  appId: "1:756285273237:web:dc0b95c312ff2c5557d79c",
  measurementId: "G-266GD746YM"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
export default firebase